import { useState } from "react";
import { useQuery } from "@apollo/client";
import GET_FACTSHEET_PDF from "../../../../graphql/queries/IIAs/getFactsheetPdf";
import withTitle from "../../../../components/withTitle";
import { useTranslation } from "react-i18next";

import IconButton from "../../../../components/IconButton";

const ExportFactsheetPdf = ({ heiId }) => {
    const { t } = useTranslation();

    const { data } = useQuery(GET_FACTSHEET_PDF, 
    { 
      notifyOnNetworkStatusChange: true, 
      fetchPolicy: 'network-only', 
      variables: { heiID: heiId} 
    })
    let base64Str = data?.factsheetPdf;
    if (base64Str) {
        let byteCharacters = atob(base64Str);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: "application/pdf;base64" });
        const fileURL = URL.createObjectURL(file);

        return (
            <a href={fileURL} target="_blank">
                      <IconButton
                          variant={"download"}
                          disabled={false}
                          title={"Download Partner Factsheet pdf"}
                      />
            </a>
        );
    }
    else {
      return (
             <>
                <IconButton
                    variant={"download"}
                    disabled={true}
                    title={""}
                />
            </>
        );
    }
};

export default ExportFactsheetPdf;
